import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { IconStarSolid } from '@instructure/ui-icons';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../../theme.js";
import generateStyle from "./styles.js";
import { hasMastery } from "../../../util/outcomesReportUtils.js";
var Score = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Score, _React$Component);
  var _super = _createSuper(Score);
  function Score() {
    _classCallCheck(this, Score);
    return _super.apply(this, arguments);
  }
  _createClass(Score, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        score = _this$props.score,
        outcome = _this$props.outcome;
      var mastery = hasMastery(score, outcome);
      var outerStyle = _objectSpread(_objectSpread({}, this.props.styles.score), mastery ? this.props.styles.mastery : {});
      return score && jsx("div", {
        css: outerStyle,
        "data-automation": "outcomesPerStudent__score"
      }, jsx("span", {
        css: this.props.styles.masteryStar
      }, mastery && jsx(IconStarSolid, {
        "data-automation": "outcomesPerStudent__masteryStar"
      })
      // eslint-disable-next-line react/jsx-closing-tag-location
      ), jsx("div", {
        css: this.props.styles.scoreText
      }, jsx(Text, {
        size: "small",
        "data-automation": "outcomesPerStudent__scoreText"
      }, score.points, "/", score.pointsPossible), jsx(Text, {
        size: "small"
      }, mastery ? t('Mastery') : t("Didn't Meet"))), jsx("span", {
        css: this.props.styles.scoreSpacer
      }));
    }
  }]);
  Score.displayName = "Score";
  return Score;
}(React.Component), _class2.propTypes = {
  score: PropTypes.object,
  outcome: PropTypes.object.isRequired,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object
}, _class2.defaultProps = {
  score: null
}, _class2)) || _class);
export { Score as default };